export default {
  CourseDetail_click_play: '0702Web-点击播放',
  CourseDetail_make_comment: '0707Web-参与评论',
  CourseDetail_Like_others_comments: '0709Web-点赞他人评论',
  CourseDetail_introduction_detail: '详细介绍：',
  CourseDetail_handleUp_introduction: "收起详细介绍",
  CourseDetail_starTip1: '很差，一分都嫌多',
  CourseDetail_starTip2: '很差，一分都嫌多',
  CourseDetail_starTip3: '一般，不太喜欢',
  CourseDetail_starTip4: '一般，不太喜欢',
  CourseDetail_starTip5: '还不错',
  CourseDetail_starTip6: '还不错',
  CourseDetail_starTip7: '很好，有收获',
  CourseDetail_starTip8: '很好，有收获',
  CourseDetail_starTip9: '非常棒，受益匪浅',
  CourseDetail_starTip10: '非常棒，受益匪浅',
  CourseDetail_resTime: '（{resTime}秒）',
  CourseDetail_exam: '考试',
  CourseDetail_pass: '通过',
  CourseDetail_noPass: '未通过',
  CourseDetail_courseRule1: '课程内全部课件已学',
  CourseDetail_courseRule2: '课程内任意课件已学',
  CourseDetail_examRule1: '需参加所有考试并及格',
  CourseDetail_examRule2: '需参加所有考试',
  CourseDetail_examRule3: '参加任意考试即可',
  CourseDetail_examRule4: '无需考试',
  CourseDetail_wearRule1: '纯视频/音频课件：观看/收听完整内容',
  CourseDetail_wearRule2: '纯视频/音频课件：观看/收听即算已学',
  CourseDetail_wearRule3: '图文/混合/游戏课件：观看即算已学',
  CourseDetail_wearRule4: '电子书课件：阅读进度达100%',
  CourseDetail_wearRule5: '图文/混合/游戏课件: 学习时长超过{value}分钟',
  CourseDetail_wearRuleTips: '(含考试课件需考试及格)',
  CourseDetail_limitTime: '限{time}前完成',
  CourseDetail_courseComRule: '课程完成规则:',
  CourseDetail_wearComRule: '课件已学条件:',
  CourseDetail_examComRule: '考试完成条件:',
  CourseDetail_catalogue: '目录',
  CourseDetail_comRule: '完成规则',
}
